import { Box, Typography } from "@mui/material";
import React from "react";
import { Icon } from "@iconify/react";
import CustomButtonComponent from "../../core/custom-button";
const ConfirmationPopup = ({ ticketId, onClose }) => {
  return (
    <div>
      <Box sx={{ display: "flex", justifyContent: "center" }}>
        <Icon
          icon="line-md:circle-to-confirm-circle-twotone-transition"
          width="10em"
          height="10em"
          style={{ color: "#34C759" }}
        />
      </Box>

      <Typography
        variant="h6"
        sx={{ mt: 2, textAlign: "center", mb: 2 }}
        className="primary-text"
      >
        Your Ticket is Successfully generated
      </Typography>
      <Typography variant="h6" className="primary-text">
        We're prioritizing your request, and Our Technical support team will
        update you shortly.
      </Typography>
      <Typography variant="h6" className="primary-text">
        You will get notified immediately once action initiated.
      </Typography>
      <Box sx={{ display: "flex", justifyContent: "center", mt: 5 }}>
        <CustomButtonComponent
          variant="contained"
          color="success"
          onClick={onClose}
        >
          Okay
        </CustomButtonComponent>
      </Box>
    </div>
  );
};

export default ConfirmationPopup;
